import apiClient from './api';

// ===== DTOs =====
export interface BaseReportFilter {
  fromDate?: string;
  toDate?: string;
  itemId?: number;
  warehouseId?: number;
  branchId?: number;
  status?: string;
  includeZeroQuantity?: boolean;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
}

export interface StockLevelDto {
  itemId: number;
  itemCode: string;
  itemName: string;
  itemNameAr: string;
  unitId: number;
  unitName: string;
  unitNameAr: string;
  warehouseId?: number;
  warehouseCode?: string;
  warehouseName?: string;
  warehouseNameAr?: string;
  branchId?: number;
  branchCode?: string;
  branchName?: string;
  branchNameAr?: string;
  quantity: number;
  reservedQuantity: number;
  availableQuantity: number;
  unitCost: number;
  totalValue: number;
  lastUpdated?: string;
}

export interface ReportSummary {
  totalQuantity: number;
  totalValue: number;
  totalRecords: number;
  fromDate?: string;
  toDate?: string;
  groupTotals?: { [key: string]: number };
}

export interface PagedReportResult<T> {
  data: T[];
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  summary: ReportSummary;
}

// ===== Service =====
export const inventoryReportsService = {
  getStockLevels: async (filter: BaseReportFilter = {}): Promise<PagedReportResult<StockLevelDto>> => {
    const params = new URLSearchParams();
    
    if (filter.fromDate) params.append('fromDate', filter.fromDate);
    if (filter.toDate) params.append('toDate', filter.toDate);
    if (filter.itemId) params.append('itemId', filter.itemId.toString());
    if (filter.warehouseId) params.append('warehouseId', filter.warehouseId.toString());
    if (filter.branchId) params.append('branchId', filter.branchId.toString());
    if (filter.status) params.append('status', filter.status);
    if (filter.includeZeroQuantity !== undefined) params.append('includeZeroQuantity', filter.includeZeroQuantity.toString());
    if (filter.pageNumber) params.append('pageNumber', filter.pageNumber.toString());
    if (filter.pageSize) params.append('pageSize', filter.pageSize.toString());
    if (filter.sortBy) params.append('sortBy', filter.sortBy);
    if (filter.sortDirection) params.append('sortDirection', filter.sortDirection);

    const response = await apiClient.get<PagedReportResult<StockLevelDto>>(
      `/inventory-reports/stock-levels?${params.toString()}`
    );
    return response.data;
  }
};